import React from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { Toaster } from 'react-hot-toast';
import Router from './router';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HashRouter basename="/">
          <Router />
          <Toaster position='bottom-center' />
        </HashRouter>
      </PersistGate>
    </Provider>
  )
}

export default App;
